<template>
	<div class="d-flex">
		<!-- TODO: imgSrc -->
		<img
			v-if="imgSrc"
			class="mr-4 ao-preview-header-image"
			:src="imgSrc"
			alt=""
		/>
		<ao-icon
			v-if="icon"
			:iconName="icon"
			:size="iconSize"
			class="mr-2 my-auto"
		/>
		<div>
			<div class="ao-h2 mb-1 text-textBody">{{ title }}</div>
			<slot name="subtitle">
				<div class="ao-p2-medium text-textSecondary700">{{ subTitle }}</div>
			</slot>
			<PreviewStatus
				v-if="status"
				class="mb-4"
				:status="status"
				color="green"
			/>
		</div>
	</div>
</template>

<script>
import PreviewStatus from '@/components/ui/preview/PreviewStatus.vue'
export default {
	name: 'PreviewHeader',
	components: {
		PreviewStatus,
	},

	props: {
		imgSrc: {
			type: String,
		},
		icon: {
			type: String,
		},
		iconSize: {
			type: String,
		},
		title: {
			type: String,
		},
		subTitle: {
			type: String,
		},
		status: {
			type: String,
		},
	},
}
</script>

<style lang="scss">
.ao-preview-header-image {
	max-width: 64px;
	max-height: 64px;
	width: 100%;
}
</style>
